import React from 'react';
import Logo from '../components/Logo';
import './About.css';

const About = () => {
  return (
    <div className="about-page">
      <section className="about-hero">
        <div className="container">
          <div className="hero-brand">
            <div className="brand-logo-text">
              <Logo size="medium" useImage={true} imageSrc="/logo.png" />
              <h1 className="brand-name-large">MunchUps</h1>
            </div>
            <div className="brand-tagline">MUNCH, CRUNCH, LOVE THE PUNCH</div>
          </div>
          <h1>About Us</h1>
          <p>Your trusted partner for traditional, authentic, and crunchy snacks</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="about-content">
            <div className="about-text">
              <h2>100% Traditional Snacks</h2>
              <h3>A Munchy Crunchy Blend of Tradition and Taste</h3>
              <p>
                MunchUps brings you authentic
                traditional snacks made with 100% real ingredients. We are committed to maintaining
                the same taste, quality and freshness that our customers love.
              </p>
              <p>
                From timeless classics to bold new flavors, MunchUps offers a wide variety of snacks crafted to satisfy every taste palate. Whether you crave something crunchy, savory, or delightfully unique, there’s always a MunchUps snack ready to match your mood and your cravings.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="section why-section">
        <div className="container">
          <h2 className="section-title">Why MunchUps?</h2>
          <p className="section-subtitle">
            MunchUps is synonymous with hygiene, quality, taste and variety
          </p>
          <div className="grid grid-4">
            <div className="why-card">
              <div className="why-icon">🏆</div>
              <h4>Quality Products</h4>
              <p>Using quality raw materials and manufactured in a hygienic production unit.</p>
            </div>
            <div className="why-card">
              <div className="why-icon">🌱</div>
              <h4>100% Fresh</h4>
              <p>
                We maintain same taste, quality and freshness in our snacks which is loved by our
                entire customers.
              </p>
            </div>
            <div className="why-card">
              <div className="why-icon">✨</div>
              <h4>Authentic Taste</h4>
              <p>MunchUps snacks made from 100% Real Ingredients to offer the Authentic Taste.</p>
            </div>
            <div className="why-card">
              <div className="why-icon">✈️</div>
              <h4>Travel Companion</h4>
              <p>
                Get this lip-smacking snack which can be your perfect partner while you travel.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
